import { Injectable } from '@angular/core';
import {  } from "rxjs/Rx";

import { DialogClick } from "./dialog.models";
@Injectable()
export class RxDialog {

    confirmation: (texts: any[], messageType: string) => Promise<DialogClick>;

    alert: (message: string,args:any[]) => Promise<boolean>;

    saveConfirmation: (text: string, args: any[]) => Promise<DialogClick>;
}


// WEBPACK FOOTER //
// ./node_modules/@rx/view/dialog/dialog.service.ts